import MenuList from "@Components/buyCarMenu/KindSumMenuList";
import KindsCompare from "@Components/kindsum/KindsCompare";
import KindSumCarList from "@Components/kindsum/KindSumCarlist";
import KindSumComment from "@Components/kindsum/kindSumComment";
import NewKindSumShowroom from "@Components/kindsum/newKindSumShowroom";
import { fetchRecommendUsedCar } from "@Services/kindsum";
import { IUserCarItem } from "@Types/kindsum";
import React, { useEffect, useState } from "react";
import { lazy, useRef } from "react";
import { useQuery } from "react-query";
import { formatThousend } from "../../utils/helper";
import ArticleDescList from "@Components/kindsum/ArticleDescList";
import HotCarCompare from "@Components/kindsum/hotCarCompare";
import { useSetState } from "ahooks";
import { fetchAllKindsModels, fetchKindsModels } from "@Services/article";
import AdIframeImage from "@Components/ad/AdFrame_v2";
import AddToPK from "@Components/Specification/addToPK";
import RightFixedBar from "@Components/Specification/rightFixedBar";
import { useAtom } from "jotai";
import { pkComparisonAtom } from "@Lib/jotai/pkCompare";
import RecommendCarCompare from "@Components/kindsum/recommendCarCompare";
import KindSumIntro from "@Components/kindsum/KindSumIntro";
import AppraiseTips from "@Components/appraiseTips";

interface IAdProps {
  data?: {
    link: string;
    img: string;
    video?: string;
  };
}
const KindSumNewDetail: React.FC<{ data: any }> = ({ data }) => {
  const [adIframe, setAdIframe] = useState<boolean>(false);
  const [params, setParams] = useSetState({
    articleId: [],
  });
  const { brandName, kindName } = data;
  const [hasCollect, setHasCollect] = useState(false);

  const [kindsModels, setKindsModels] = useState<{ title: string, data: any[] }[]>([]);
  const [stopSalesKindsYearsItem, setStopSalesKindsYearsItem] = useState({ new_kind_id: "", saleStatus: "" });
  const [openPK, setOpenPK] = useState(false);
  const [pkDataCount, setPkDataCount] = useState(0);
  const [globalPkList] = useAtom(pkComparisonAtom);

  const { articleId } = params;
  const { data: userCarData = [], refetch } = useQuery<Array<IUserCarItem>>(
    [`fetchRecommendUsedCar`, window.query_kind_id],
    async () => {
      const res: { data; status } = await fetchRecommendUsedCar({ kindId: window.query_kind_id, limit: 8 });
      return res?.status === 12000 ? res?.data.items : [];
    },
  );

  useEffect(() => {
    if (hasCollect) return;
    if (kindName) {
      localStorage.setItem("nc_brand", brandName || "");
      localStorage.setItem("nc_kind", kindName || "");
      setHasCollect(true);
    }
  }, [data, hasCollect]);

  const Item = ({ data }: IAdProps) => {
    useEffect(() => {
      if (data && Object.keys(data).length === 0) {
        setAdIframe(true);
      }
    }, [data]);

    return (
      <>
        {data && Object.keys(data).length !== 0 && (
          <a href={data.link} className='w-280 h-320 absolute top-0 left-0' target='_blank'>
            <img src={data.img} className='w-full h-full' />
          </a>
        )}
      </>
    );
  };

  const consultRef = useRef(null);

  const getKindsModels = async () => {
    try {
      const res: any = await fetchAllKindsModels({
        kindId: window.query_kind_id,
        nk: stopSalesKindsYearsItem.new_kind_id,
        saleStatus: stopSalesKindsYearsItem.saleStatus,
        needEquip: 1
      });
      if (res?.status === 12000) {
        const newList: any[] = []
        res.data.list.forEach((item) => {
          const title = `${!!item.year ? item.year + '年式' : ''} ${item.power} ${!!item.gas && (item.gas != '0' ? item.gas + 'L' : '')}`;
          const index = newList.findIndex((item) => item.title === title)

          if (index === -1) {
            newList.push({
              title,
              data: [item]
            })
          } else {
            newList[index].data.push(item);
          }
        })
        setKindsModels(newList)
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    stopSalesKindsYearsItem.new_kind_id !== "" && getKindsModels();
  }, [stopSalesKindsYearsItem.new_kind_id, stopSalesKindsYearsItem.saleStatus]);

  // 监听PK比较数据
  useEffect(() => {
    setPkDataCount(globalPkList.length || 0)
  }, [globalPkList]);

  return (
    <div className='flex justify-between'>
      {/* 左侧内容 */}
      <div className='w-890 relative'>
        {!!data.kindId && (
          <>
            {/* 車款介紹 */}
            <KindSumIntro data={data} />
            {/* 横向文章列表 */}
            <KindSumCarList consultRef={consultRef} data={data} setParams={setParams} />
            {/* 比较列表 */}
            <KindsCompare data={kindsModels} sumData={data} onChange={(e) => setStopSalesKindsYearsItem(e)} setOpenPK={setOpenPK} />
            {/* 購車菜單 */}
            <MenuList
              title={`${data.brandName} ${data.kindName} 購車菜單`}
              source={"綜述頁-購車菜單版位卡片-徵求菜單"}
              containtStyle={{ width: "890px" }}
              itemsStyle={{ width: "890px" }}
              titleStyle={{ fontSize: "18px", fontWeight: "500" }}
              gaId={"KindSummaryItem"}
              brandId={data.brandId}
              kindId={data.kindId}
            />

            {/* 車友評價 */}
            <KindSumComment dataSource={data} />

            {/* 展示間 */}
            {!!data.inquiry.showroomNum && (
              <div className='flex flex-col mt-40'>
                <div className='text-20 text-black font-[600] mb-24'>{`${data.brandName} ${data.kindName} 展示間`}</div>
                <NewKindSumShowroom kindId={data.kindId} brandId={data.brandId} />
              </div>
            )}
            {/* 中古車 */}
            {!!userCarData?.length && (
              <div className='flex flex-col mt-40'>
                <div className='text-20 text-black font-[600] mb-24 flex items-center justify-between'>
                  {`${data.brandName} ${data.kindName} 中古車`}
                </div>
                <div className='grid gap-22 flex-wrap mb-24' style={{ gridTemplateColumns: "repeat(4, 206px)" }}>
                  {userCarData.map((item, index) => (
                    <a
                      href={item.link}
                      className='border-1 border-solid border-[#E8E8E8] flex flex-col rounded-8 relative'
                      key={index}
                      target='_blank'
                      id={"SummaryUserCarItem"}
                    >
                      {!!item?.pcSuperTop && (
                        <i
                          style={{ background: "linear-gradient(270deg,#ffb062, #ff8625)" }}
                          className='rounded-tl-8 rounded-br-8 absolute top-0 left-0 text-[#fff] px-10 h-26 flex items-center'
                        >
                          精選
                        </i>
                      )}
                      <img
                        src={item.thumb}
                        alt=''
                        className='w-[204px] h-[156px] rounded-tl-8 rounded-tr-8 object-cover'
                      />
                      <div className='px-10 pt-8 pb-14'>
                        <div className='flex items-center h-44'>
                          <p className='text-16 leading-20 text-[#1B1B1B] font-normal max-h-38 line-clamp-2 mb-14'>
                            {item.title}
                          </p>
                        </div>
                        <p className='text-14 leading-20 text-[#666660] font-normal mb-14'>
                          {item.year}式 | {formatThousend(item.mileageNum)}
                        </p>
                        <p className='text-14 leading-24 text-[#FF963C] font-medium'>{formatThousend(item.price)}</p>
                      </div>
                    </a>
                  ))}
                </div>

                <a
                  href={`https://auto.8891.com.tw?b=${data.brandId}&k=${data.kindId}`}
                  id={"SummaryUserCarMoreLink"}
                  target='_blank'
                  className='text-14 text-[#666] flex justify-center items-center bg-[#f4f4f4] w-140 h-34 mx-auto mb-20 hover:text-[#666]'
                >
                  查看更多
                </a>
              </div>
            )}

            {/* 文章列表 */}
            <div ref={consultRef}>
              <ArticleDescList articleId={articleId} data={data} />
            </div>
          </>
        )}
      </div>

      {/* 右侧内容 */}
      <div className='w-280 pt-40 flex flex-col' id='summaryRightContent'>
        {data.inquiry.isInquiry === 1 && (
          <div className='relative'>
            <AdIframeImage
              slot={"/173427088/newcar-pc-summary-right-top"}
              size={[["fluid"], ["fluid"]]}
              width={280}
              height={280}
              styles={{ width: 280, height: 280, marginBottom: "40px" }}
            />
          </div>
        )}

        <div className='relative'>
          <AdIframeImage
            slot={"/173427088/newcar_pc_summary_pk_topbanner"}
            size={[["fluid"], ["fluid"]]}
            width={280}
            height={72}
            styles={{ width: 280, height: 72, marginBottom: "40px" }}
          />
        </div>

        {/* 熱門車型對比 */}
        {/* {!!data.kindId && <HotCarCompare kindId={data.kindId} />} */}
        {!!data.kindId && <RecommendCarCompare kindId={data.kindId} />}

        <div
          className='relative w-280 h-[352px] mb-40'
          style={{
            background: "linear-gradient(180deg,#fff8eb, #fffbf2 100%)",
          }}
        >
          <AppraiseTips />
        </div>

        <div className='relative'>
          <AdIframeImage
            slot={"/173427088/新版車款綜述頁-右側看板"}
            size={[["fluid"], [280, 560]]}
            width={280}
            height={560}
            styles={{
              width: "280px",
              height: "560px",
              background: "#ccc",
              marginBottom: "40px"
            }}
          />
        </div>

        <div className={`dfp-fluid dfp-h5 relative ${adIframe ? "none" : ""}`}>
          {hasCollect && (
            <AdIframeImage
              slot={"/173427088/auto-pc-sell-vehicleSource-tow"}
              size={[["fluid"], [280, 320]]}
              width={280}
              height={320}
            >
              <Item />
            </AdIframeImage>
          )}
        </div>
      </div>


      {/* 加入PK比较抽屉 */}
      <AddToPK open={openPK} onClose={() => setOpenPK(false)} />
      {/* 右侧置顶固定栏 */}
      <RightFixedBar
        items={[
          {
            defaultSrc: 'https://photo.8891.com.tw/2024/11/11/1731308340899356.png',
            hoverSrc: 'https://photo.8891.com.tw/2024/11/11/1731305235679649.png',
            label: <div className='relative'>
              {!!pkDataCount && <i
                className='bg-[#FF2101] rounded-full flex items-center justify-center absolute -top-34 left-16 text-14 text-white min-w-[16px] h-16 inline-block w-fit'
              >{pkDataCount > 99 ? '99+' : pkDataCount}</i>}
              比較
            </div>,
            id: 'tracking-RightPKBtn',
            itemIndex: 0,
            handleClick: () => {
              setOpenPK(true)
            }
          }
        ]}
        scrollTopNum={176}
      />
    </div>
  );
};

export default KindSumNewDetail;
